module.exports = __webpack_public_path__ + "static/media/no-icon.0b00fee0.png";